import { LazyRequestAccessConfirmationModal } from './LazyRequestAccessConfirmationModal';
import React from 'react';
import { BoardModel } from './RequestAccessConfirmationModal';
import Dialog from 'app/scripts/views/lib/dialog';

export const OpenAutoInviteDialog = (
  inviteMemberId: string,
  board: BoardModel,
) => {
  Dialog.show({
    reactElement: (
      <LazyRequestAccessConfirmationModal
        boardModel={board}
        idMember={inviteMemberId}
        onClose={Dialog.hide}
      />
    ),
    maxWidth: 550,
    displayType: 'auto-invite-dialog',
  });
};
